module.exports = __webpack_public_path__ + "img/logo.944d6085.png";